import { ReactElement } from 'react';
import { getSchema } from '@localstack/services';
import Firehose from 'aws-sdk/clients/firehose';

import { MagicDetails } from '../../magic/MagicDetails';

export interface FirehoseStreamDetailsProps {
  deliveryStream?: Optional<Firehose.DescribeDeliveryStreamOutput>;
}

export const FirehoseStreamDetails = ({ deliveryStream }: FirehoseStreamDetailsProps): ReactElement => (
  <MagicDetails
    data={deliveryStream?.DeliveryStreamDescription}
    schema={getSchema('Firehose')}
    entry="DeliveryStreamDescription"
    title="Delivery Stream Table Details"
  />
);
